<template>
  <div class="row">
    <div class="col-md-8">
      <div class="card card-default">
        <service-wizard-layout
          title="Rocketseed"
          subtitle=""
          :parts="parts"
          :onComplete="onComplete"
          :validateStep="validateStep"
        >
          <template v-slot:package>
            <form novalidate data-vv-scope="package">
              <div class="row">
                <div class="col-xl-8 col-lg-12">
                  <div 
                    class="form-group" 
                    :class="{'has-error': errors.has('package')}"
                  >
                    <label>Package</label>
                    <v-select
                      :options="filledInSaleDefinition.selectableOptions.rocketPackage"
                      placeholder="Select Package"
                      label="description"
                      valueProp="rocketseedPackageNumber"
                      name="package"
                      v-validate="'required'"
                      v-model="filledInSaleDefinition.requiredObjs.customer.rocketseedPackageNumber"
                    ></v-select>
                    <span class="has-error" v-if="errors.has('package')">
                        {{errors.first('package')}}</span>
                  </div>
                </div>
              </div>
            </form>
          </template>
          <template v-slot:customer>
            <form novalidate data-vv-scope="customer">
              <div class="row">
                <div class="col-6">
                  <div 
                    class="form-group" 
                    :class="{'has-error': errors.has('customer.customerName')}"
                  >
                    <label>Name</label>
                    <input 
                        name="customerName" 
                        v-validate="'required'" 
                        class="form-control" 
                        v-model="filledInSaleDefinition.requiredObjs.customer.customerName"
                    />
                    <span class="has-error" v-if="errors.has('customer.customerName')">
                        {{errors.first('customer.customerName')}}</span>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-2">
                  <div 
                    class="form-group" 
                    :class="{'has-error': errors.has('details.noSeats')}"
                  >
                    <label>No. of Seats</label>
                    <input 
                        name="noSeats" 
                        type="number"
                        class="form-control"
                        v-validate="'required'"
                        v-model="filledInSaleDefinition.requiredObjs.details.noSeats"
                    />
                    <span class="has-error" v-if="errors.has('details.noSeats')">
                        {{errors.first('details.noSeats')}}</span>
                  </div>
                </div>
                <div class="col-4">
                  <div 
                    class="form-group" 
                    :class="{'has-error': errors.has('details.customSetupFee')}"
                  >
                    <label>Setup Fee</label>

                    <div class="input-group">
                      <div class="input-group-prepend">
                        <span class="input-group-text">R</span>
                      </div>
                      <input 
                          name="customSetupFee" 
                          class="form-control"
                          type="number"
                          v-model="filledInSaleDefinition.requiredObjs.details.customSetupFee"
                      />
                      <span class="has-error" v-if="errors.has('details.customSetupFee')">
                          {{errors.first('details.customSetupFee')}}</span>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </template>
        </service-wizard-layout>
      </div>
    </div>
  </div>
</template>

<script>
import PriceFunctions from "@/components/Admin/PriceFunctions";
import ServiceWizardLayout from "@/layouts/ServiceWizardLayout";
import { getProduct } from "../../../api/v1/products.api";

export default {
  extends: PriceFunctions,
  components: {
    ServiceWizardLayout,
  },
  props: {
    emptySaleDefinition: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      parts: [
        {
          name: "package",
          displayName: "Package",
        },
        {
          name: "customer",
          displayName: "Rocketseed Details",
        },
      ],
      filledInSaleDefinition: {
        requiredObjs: {
          customer: {
            rocketseedPackageNumber: 0
          },
          details: {
            noSeats: 0,
          }
        },
        selectableOptions: {

        },
        supportingEnums: {

        },
      },
    };
  },
  mounted() {
    this.filledInSaleDefinition = this.emptySaleDefinition;
  },
  methods: {
    onComplete() {
      this.$emit("createSale", this.filledInSaleDefinition);
    },
    getPackage() {
      if (this.filledInSaleDefinition.requiredObjs.customer.rocketseedPackageNumber > 0) {
        this.$http.get(this.$config.aimsAPI + "pricing/rocketseedpackage/" + this.filledInSaleDefinition.requiredObjs.customer.rocketseedPackageNumber)
          .then((response) => {
            this.filledInSaleDefinition.requiredObjs.details.customSetupFee = this.getDefaultSetupFee(response.data, this.getCurrentPeriod());
          },(error) => {
            this.showError("Error fetching Rocketseed Packages", error);
            console.error(error);
          }
        );
      }
    },
    getDefaultSetupFee(data, period) {
      if (data) {
        if (data.length > 0) {
          let price = data.filter((price) => period >= price.validFrom);
          price.forEach((newPrice) => {
            if (newPrice.validUntil != 0) {
              price = price.filter((price) => period <= price.validUntil);
            } else {
              price = newPrice;
            }
          });
          if (Array.isArray(price)) {
            if (price.length > 0) {
              return parseFloat(price[0].setupfee);
            } else {
              return 0.00;
            }
          } else {
            return parseFloat(price.setupfee);
          }
        } else {
          return 0.00;
        }
      } else {
        return 0;
      }
    },
    validateStep(scope) {
      return this.$validator.validateAll(scope).then((result) => {
        if (result) {
          this.getPackage();
          return true;
        } else {
          return false;
        }
      });
    },
  },
};
</script>
